import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from '../Gallery/Modal';

function FooterFour() {
    return (
        <footer className="footer-wrapper bg-title footer-layout2">
            <div className="widget-area">
                <div className="container">
                    <div className="row justify-content-between align-items-center py-4">
                        <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                            <div className="th-widget-about">
                                <div className="about-logo mb-2">
                                    <Link to="/">
                                        <img src="/assets/img/koorditel.png" alt="GIS Telekomunikasi" style={{maxWidth:'180px'}} />
                                    </Link>
                                </div>
                                <p className="about-text mb-2">
                                    GIS Monitoring Telekomunikasi &amp; WiFi Kabupaten adalah platform peta interaktif untuk memantau, menganalisis, dan mengelola infrastruktur menara telekomunikasi serta lokasi WiFi publik secara real-time.
                                </p>
                                <div className="th-social mt-2">
                                    <a href="mailto:admin@petawifi.com" title="Email"><i className="fas fa-envelope" /></a>
                                    <a href="https://wa.me/6281234567890" title="WhatsApp"><i className="fab fa-whatsapp" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                            <div className="widget widget_nav_menu footer-widget">
                                <h3 className="widget_title">Navigasi</h3>
                                <ul className="menu">
                                    <li><Link to="/">Beranda</Link></li>
                                    <li><Link to="/about">Tentang</Link></li>
                                    <li><Link to="/contact">Kontak</Link></li>
                                    <li style={{display:'none'}}><a href="/admin" data-discover="true"><i className="fas fa-chart-bar"></i> Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <div className="widget footer-widget">
                                <h3 className="widget_title">Kontak</h3>
                                <div className="th-widget-contact">
                                    <div className="info-box_text d-flex align-items-center mb-2">
                                        <i className="fas fa-map-marker-alt me-2"></i>
                                        <span>Diskominfo Kabupaten (contoh), Indonesia</span>
                                    </div>
                                    <div className="info-box_text d-flex align-items-center mb-2">
                                        <i className="fas fa-envelope me-2"></i>
                                        <a href="mailto:admin@petawifi.com" className="info-box_link">admin@petawifi.com</a>
                                    </div>
                                    <div className="info-box_text d-flex align-items-center">
                                        <i className="fab fa-whatsapp me-2"></i>
                                        <a href="https://wa.me/6281234567890" className="info-box_link">+62 812-3456-7890</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-center text-white-50 small mt-3 pt-2 border-top border-light">
                        &copy; {new Date().getFullYear()} GIS Telekomunikasi &amp; WiFi Kabupaten. All rights reserved.
                    </div>
                </div>
            </div>
        </footer>
    );

}

export default FooterFour
